var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPupil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 108,
    viewBox: "0 0 118 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 64.5C6 99 61.0001 113 92.5 92.5C124 72 119.5 5.99999 67.9999 6C16.5001 6.00001 6 30 6 64.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPupil);
export default __webpack_public_path__ + "static/media/pupil.5e600411418a3b388671699d5fb39fd3.svg";
export { ForwardRef as ReactComponent };